import { useState } from "react";
import { useNavigate } from "react-router";
import React from "react";
import { cn } from "../../../lib/utils";
import { ArrowLeft } from "lucide-react";
import { AuthFormProps } from "../types";
import { useResetPasswordController } from "../hooks";

import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { AuthCard, FormError, AuthLayout } from "../components";

export const ResetPassword: React.FC<AuthFormProps> = ({ className }) => {
  const navigate = useNavigate();
  const controller = useResetPasswordController();
  const [resetRequested, setResetRequested] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await controller.reset();
    setResetRequested(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const renderEmailField = () => (
    <div className="grid gap-2">
      <Label htmlFor="email">Email</Label>
      <Input
        id="email"
        type="email"
        placeholder="your@email.com"
        disabled={controller.loading}
        onChange={(e) => controller.setEmail(e.target.value)}
        value={controller.email}
        autoComplete="email"
        className={cn(controller.errorMessage ? "border-destructive" : "")}
        onKeyDown={handleKeyDown}
      />
      <FormError message={controller.errorMessage} />
    </div>
  );

  return (
    <AuthLayout>
      <AuthCard
        title="Reset your password"
        description="Enter your email address and we'll send you a link to reset your password"
        className={className}
      >
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-4">
            {renderEmailField()}

            <Button
              type="submit"
              className="w-full"
              disabled={controller.loading || !controller.email}
            >
              {controller.loading ? "Sending reset link..." : "Reset password"}
            </Button>
          </div>
        </form>
        <div className="mt-4 text-center">
          <Button
            variant="link"
            className="text-sm inline-flex items-center gap-1"
            onClick={() => navigate("/app/login")}
          >
            <ArrowLeft className="h-4 w-4" /> Back to sign in
          </Button>
        </div>
      </AuthCard>
    </AuthLayout>
  );
};
